import { useState, useEffect } from 'react';
import { getAppConfigs } from '../lib/api';
import type { AppConfig } from '../types';

let cache: AppConfig[] | null = null;
let cachedNotionDbUrl: string = '';

function applyColors(configs: AppConfig[]) {
  configs.forEach(app => {
    document.documentElement.style.setProperty(app.cssVar, app.color);
    const hex = app.color.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    document.documentElement.style.setProperty(`${app.cssVar}-rgb`, `${r},${g},${b}`);
  });
}

export function useAppConfigs() {
  const [apps, setApps]               = useState<AppConfig[]>(cache ?? []);
  const [notionDbUrl, setNotionDbUrl] = useState(cachedNotionDbUrl);
  const [loading, setLoading]         = useState(!cache);

  useEffect(() => {
    if (cache) { setApps(cache); setNotionDbUrl(cachedNotionDbUrl); setLoading(false); return; }
    getAppConfigs()
      .then(res => {
        // Backward-compatible: backend puede retornar array (viejo) u objeto (nuevo)
        const configs = Array.isArray(res) ? res : (res.apps ?? []);
        const url     = Array.isArray(res) ? '' : (res.notionDbUrl ?? '');
        cache = configs;
        cachedNotionDbUrl = url;
        setApps(configs);
        setNotionDbUrl(url);
        applyColors(configs);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const refetch = (): Promise<void> => {
    cache = null;
    setLoading(true);
    return getAppConfigs()
      .then(res => {
        const configs = Array.isArray(res) ? res : (res.apps ?? []);
        const url     = Array.isArray(res) ? '' : (res.notionDbUrl ?? '');
        cache = configs;
        cachedNotionDbUrl = url;
        setApps(configs);
        setNotionDbUrl(url);
        applyColors(configs);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  return { apps, notionDbUrl, loading, refetch };
}
